import { useState } from 'react';
import { useLazyAuthenticateQuery } from '@api/api';
import { useLocale, useTranslations } from 'next-intl';
import { RootState } from '@/src/redux/store';
import { userState } from '@/src/redux/userSlice/userSlice';
import { useSelector } from 'react-redux';

export default function AuthenticateBox({
  theme = 'yellow',
}: {
  theme?: string;
}) {
  const user: userState = useSelector((state: RootState) => {
    return state.user;
  });
  const locale = useLocale();
  const [authenticationError, setAuthenticationError] = useState('');
  const [authenticate, { isFetching }] = useLazyAuthenticateQuery();
  const t = useTranslations('user');
  const startAuthentication = (
    method: string | void,
    country?: string | void
  ) => {
    setAuthenticationError('');
    authenticate({ method, country }).then((res) => {
      if (res.data?.url) {
        window.location = res.data?.url;
      } else {
        setAuthenticationError('Unknown error, try again later');
      }
    });
  };

  const buttonClass = `uppercase p-2 px-4 font-semibold ${
    theme === 'yellow'
      ? 'border border-brand bg-brand text-black hover:bg-black hover:text-white focus:bg-black focus:text-white'
      : 'border border-black bg-black text-white hover:bg-brand hover:text-black focus:bg-brand focus:text-black'
  }`;
  const secondaryButtonClass = `uppercase p-2 px-4 font-semibold bg-black ${
    theme === 'yellow'
      ? 'border border-brand hover:bg-black hover:text-white'
      : 'border border-black bg-brand text-black hover:border-brand hover:bg-black hover:text-brand'
  }`;

  return (
    <div className='mb-4 py-2'>
      <h3
        className={`${theme === 'yellow' ? 'text-center text-2xl' : 'text-lg'} mb-2 font-bold`}
      >
        {t('authenticate')}
      </h3>
      <div className='my-2 grid gap-4 md:grid-cols-2'>
        {(!user.country ||
          ['NORWAY', 'NORGE', 'NO'].includes(user.country.toUpperCase()) ||
          process.env.NEXT_PUBLIC_DEFAULT_LOCALE === 'no') && (
          <button
            className={buttonClass}
            onClick={() => startAuthentication('eIDAS', 'no')}
          >
            {t('norwegianBankID')}
          </button>
        )}
        {(!user.country ||
          ['SWEDEN', 'SVERIGE', 'SE', 'SV'].includes(
            user.country.toUpperCase()
          ) ||
          process.env.NEXT_PUBLIC_DEFAULT_LOCALE === 'sv') && (
          <button
            className={buttonClass}
            onClick={() => startAuthentication('eIDAS', 'se')}
          >
            {t('swedishBankID')}
          </button>
        )}
        <button
          className={secondaryButtonClass}
          onClick={() => startAuthentication()}
        >
          {t('anotherIdentity')}
        </button>
      </div>
      {isFetching && <>{t('authenticationStarted')}</>}
      {!authenticationError && (
        <p className='mx-4 -mt-4 mb-3 text-white'>{authenticationError}</p>
      )}
    </div>
  );
}
